var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('span',[_vm._v("\n  "+_vm._s(_vm.$i18n.format(_vm.value))+" "+_vm._s(_vm.$i18n.translateUnit('kg/ha'))+"\n")]):_c('span',[_vm._v("\n  -\n")])}
var staticRenderFns = []

export { render, staticRenderFns }